module.exports = __webpack_public_path__ + "static/media/anxilla_logo.e1b61e21.png";